import * as React from 'react';
import * as _ from 'lodash';
import { ButtonRadio,ButtonRadioWhite,ButtonRadioInside,InputRadio,RadioOptions,RadioOption,LabelRadio } from './styles';
import { LabelMessage } from './styles';
import { cancel } from 'redux-saga/effects';

export interface RadioButtonListItem {
    id: string;
    name: string;
    enable?: boolean;
    itemMessage?: string;
    checked?: boolean;
}

export interface RadioButtonListProps {
    name?: string;
    RadioButtonListItems?: RadioButtonListItem[]
    onSelectedItem:any;
}

const RadioButtonList = (props: RadioButtonListProps) => {

    return (
        <RadioOptions>
            {
                props.RadioButtonListItems?.map((item) => renderRadioItem(item))
            }
        </RadioOptions>
    );

    function renderRadioItem(item: RadioButtonListItem) {
        return (
            <RadioOption key={`radio${item.id}`}>
                <InputRadio
                    id={item.id}
                    type="radio"
                    name={props.name}
                    value={item.id}
                    disabled={!item.enable}
                    checked={item.checked}
                    onChange={(e) => {
                        if(item.enable || item.enable===undefined){
                            props.onSelectedItem(e.currentTarget.value);
                        }
                    }}/>
                <LabelRadio htmlFor={(item.enable || item.enable===undefined)?item.id:undefined} enabled={item.enable}> {item.name}</LabelRadio>
                <LabelMessage enabled={item.enable}> {item.itemMessage}</LabelMessage>
                <ButtonRadio enabled={item.enable}></ButtonRadio>
                <ButtonRadioWhite></ButtonRadioWhite>
                <ButtonRadioInside></ButtonRadioInside>
            </RadioOption>
        )
    }
}

export default RadioButtonList;
